export function buildPelletsCheckoutQuery(
  zipCode: string,
  amount: number | string,
  prod = "loose",
): Record<string, string> {
  return {
    zipcode: zipCode,
    amount: amount.toString(),
    unloading_points: "1",
    deliveryTimes: "normal",
    quality_steps: "isoNorm, enPlus, dinPlus",
    payment_type: "all",
    prod,
    hose: "thirtyMetre",
    short_vehicle: "withTrailer",
  };
}
